import { render, staticRenderFns } from "./labelIndex.vue?vue&type=template&id=3b8911ec"
import script from "./labelIndex.vue?vue&type=script&lang=js"
export * from "./labelIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8911ec')) {
      api.createRecord('3b8911ec', component.options)
    } else {
      api.reload('3b8911ec', component.options)
    }
    module.hot.accept("./labelIndex.vue?vue&type=template&id=3b8911ec", function () {
      api.rerender('3b8911ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/categoryLabelManage/labelIndex.vue"
export default component.exports